import { Skeleton, Stack } from "@mui/material";

export const RelatedPartyRowSkeleton = () => (
  <Stack
    direction="row"
    alignItems="center"
    sx={({ palette }) => ({
      border: `1px solid ${palette.divider}`,
      borderBottom: "0",
      "&:last-child": {
        borderBottom: `1px solid ${palette.divider}`,
      },
      px: 3,
      py: 1.5,
    })}
  >
    <Stack gap={0.5} ml={1} flex={1}>
      <Skeleton variant="text" width={120} />
      <Skeleton variant="text" width={80} sx={{ fontSize: "0.75rem" }} />
    </Stack>
    <Skeleton variant="circular" width={24} height={24} />
  </Stack>
);
